<template>
  <div class="app-bg"></div>
  <router-view />
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue';

import LazyImageLoader from '@/utils/lazy-image-loader';

export default defineComponent({
  setup() {
    onMounted(async () => {
      new LazyImageLoader('app');
    });
  },
});
</script>

<style lang="scss">
.app-bg {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: black;
  z-index: $z-index-app-background;
}
</style>
